// https://github.com/biati-digital/glightbox

import GLightbox from 'glightbox'

GLightbox({
  loop: false,
  onOpen: () => {
    const images = document.getElementsByTagName('img')

    for (let i = 0; i < images.length; i++) {
      images[i].addEventListener('contextmenu', (event) => event.preventDefault())
    }
  }
})
